module.exports = __webpack_public_path__ + "img/rockola_r.d616699b.png";